import { getCurrentInstance } from 'vue'
import mitt from "mitt"

export default function useEmitter() {
    const internalInstance = getCurrentInstance(); 
    const emitter = internalInstance!.appContext.config.globalProperties.emitter;
    return emitter as ReturnType<typeof mitt> ;
}